<script>
export default {
    props: {
        'tracts': {
            type: Number,
            required: true
        }
    },
    data(){
        return {
            activeTract: 1
        }
    },
    methods: {
        navClass(tract){
            let c = "hover:underline cursor-pointer px-2"
            if(tract != 1)
                c += " border-l border-green"
            if(tract == this.activeTract)
                return c + " text-yellow"
            return c
        }
    }
}
</script>
<template>
    <div>
        <div class="flex font-body text-green justify-center my-3">
            <template v-for="tract in tracts">
                <p :key="tract" :class="navClass(tract)" @click="activeTract = tract">Tract {{ tract }}</p>
            </template>
        </div>
        <div v-for="tract in tracts" v-if="tract == activeTract">
            <slot :name="'tract-' + (tract - 1)"></slot>
        </div>
        <!-- Display the modal -->
        <slot></slot>
    </div>
</template>